"use client";

import { memo } from "react";
import {
  useA2UIComponent,
  type A2UIComponentProps,
  type Types,
} from "@a2ui/react";

function toSnakeCase(str: string): string {
  return str.replace(/([A-Z])/g, "_$1").toLowerCase();
}

export const BeeOSIcon = memo(function BeeOSIcon({
  node,
  surfaceId,
}: A2UIComponentProps<Types.IconNode>) {
  const { resolveString } = useA2UIComponent(node, surfaceId);
  const props = node.properties;
  const iconName = resolveString(props.name);

  if (!iconName) return null;

  const snakeCaseName = toSnakeCase(iconName);

  const hostStyle: React.CSSProperties =
    node.weight !== undefined ? ({ "--weight": node.weight } as React.CSSProperties) : {};

  return (
    <div className="a2ui-icon" style={hostStyle}>
      <span className="g-icon text-muted-foreground text-xl leading-none">
        {snakeCaseName}
      </span>
    </div>
  );
});
